import React from 'react';
import MockupShell from './MockupShell';

const TEMPLATES = [
  { name: 'Crypto Beginners',     niche: 'Crypto onboarding', cvr: '12.4%', leads: 84, published: true,  accent: 'from-amber-500/30 to-yellow-600/10' },
  { name: 'Side-Hustle Builder',   niche: 'Side income',        cvr: '9.8%',  leads: 47, published: true,  accent: 'from-yellow-500/30 to-orange-600/10' },
  { name: 'Free Webinar Opt-In',   niche: 'Education',           cvr: '15.1%', leads: 23, published: false, accent: 'from-amber-600/30 to-orange-500/10' },
  { name: 'List Builder Pre-Launch', niche: 'List building',     cvr: '11.7%', leads: 0,  published: false, accent: 'from-yellow-600/20 to-amber-500/10' },
  { name: 'Mom-Boss Funnel',       niche: 'Lifestyle',           cvr: '13.2%', leads: 0,  published: false, accent: 'from-orange-500/30 to-yellow-500/10' },
  { name: 'Veteran Builder Page',  niche: 'Veteran-focused',     cvr: '10.5%', leads: 0,  published: false, accent: 'from-amber-500/20 to-orange-600/10' },
];

export default function LeadCaptureTemplates() {
  return (
    <MockupShell
      title="Lead Capture Templates"
      subtitle="Pre-built pages you can clone, customize with your photo + voice, and publish in minutes."
      dataTestId="mockup-lead-capture"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>What you can / cannot say.</strong> No income guarantees. No medical or financial
        promises. No fake testimonials. Each template has admin-approved compliance copy baked in —
        edit your hook and CTA, leave the disclaimer block intact.
      </div>

      <div className="mk-grid mk-grid--3" style={{ marginBottom: 18 }}>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Templates available</span><span className="mk-stat-value">6</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Pages published</span><span className="mk-stat-value">3</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Leads captured (30d)</span><span className="mk-stat-value">154</span></div></div>
      </div>

      <div className="mk-grid mk-grid--3">
        {TEMPLATES.map((t, i) => (
          <div key={t.name} className="mk-card" data-testid={`template-${i}`} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {/* Faux preview */}
            <div
              aria-hidden
              style={{
                height: 130,
                borderRadius: 10,
                background: 'linear-gradient(135deg, rgba(245,197,66,0.18), rgba(245,158,11,0.06))',
                border: '1px solid var(--mk-border-2)',
                padding: 12,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <div style={{ width: 70, height: 8, background: 'rgba(245,197,66,0.4)', borderRadius: 4, marginBottom: 8 }} />
                <div style={{ width: '90%', height: 12, background: 'var(--mk-text)', opacity: 0.7, borderRadius: 4, marginBottom: 4 }} />
                <div style={{ width: '70%', height: 12, background: 'var(--mk-text)', opacity: 0.4, borderRadius: 4 }} />
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <div style={{ flex: 1, height: 18, background: 'rgba(245,197,66,0.3)', borderRadius: 4 }} />
                <div style={{ width: 60, height: 18, background: 'var(--mk-gold)', borderRadius: 4 }} />
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: 15 }}>{t.name}</h3>
              {t.published
                ? <span className="mk-badge mk-badge--success">Published</span>
                : <span className="mk-badge mk-badge--muted">Not used yet</span>}
            </div>
            <div style={{ fontSize: 12, color: 'var(--mk-muted)', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <span>Niche: <strong style={{ color: 'var(--mk-text)' }}>{t.niche}</strong></span>
              <span>Avg CVR: <strong style={{ color: 'var(--mk-gold)' }}>{t.cvr}</strong></span>
              <span>Leads: <strong style={{ color: 'var(--mk-text)' }}>{t.leads}</strong></span>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button className="mk-btn" data-testid={`template-use-${i}`}>Use template</button>
              <button className="mk-btn mk-btn--ghost">Preview</button>
            </div>
          </div>
        ))}
      </div>
    </MockupShell>
  );
}
